import {
  Box,
  styled,
  Typography,
  LinearProgress,
  linearProgressClasses,
} from '@mui/material';

export const ProviderSettingsWrapper = styled(Box)(({ theme }) => ({
  // marginBottom: 16,
}));

export const MainTitle = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '23.44px',
  color: '#3C4350',
  marginBottom: 32,
}));

export const ComingSoonText = styled(Typography)({
  fontWeight: 400,
  fontSize: '20px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  verticalAlign: 'middle',
  color: '#929398',
});

// export const ComingSoonProgress = styled(LinearProgress)({
//   width: '134px',
//   backgroundColor: '#929398',
// });

export const ComingSoonProgress = styled(LinearProgress)(({ theme }) => ({
  height: 7,
  borderRadius: 5,
  width: '134px',
  border: '1px solid #929398',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#fff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#fff',
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#929398',
    ...theme.applyStyles('dark', {
      backgroundColor: '#929398',
    }),
  },
}));

export const ComingSoonWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  padding: '46.5px',
});
